export class EditCompanyProfile{

  constructor(
    private firstName: string,
    private lastName: string,
    private companyName: string,
    private marketingAgreement: boolean){
  }
}
